import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Button from 'components/shared/button';
import Link from 'components/shared/link';
import Logo from 'images/logo.inline.svg';
import MainContext from 'context/main';
import Menu from './menu';
import Burger from './burger';

import styles from './header.module.scss';

const cx = classNames.bind(styles);

const Header = ({ layout, theme, withGradient, isBurgerToggled, onBurgerClick }) => {
  console.log(theme);

  const {
    menus: {
      header: {
        menuItems: { nodes: menuItemsNodes },
      },
    },
    sharedBlocks: {
      header: {
        acf: { buttonText, buttonLink, link },
      },
    },
  } = useContext(MainContext);

  // We always need to switch to primary theme when mobile navigation is open
  const currentTheme = isBurgerToggled ? 'primary' : theme;
  const buttonTheme = theme === 'primary' ? 'accent-primary' : 'tertiary';

  const { title: linkTitle, url: linkUrl } = link || {};

  return (
    <header
      className={cx('wrapper', currentTheme, { withGradient, mobileMenuIsOpen: isBurgerToggled })}
    >
      <div className="container">
        <div className={cx('inner')}>
          <Link to="/">
            <Logo className={cx('logo')} />
          </Link>

          {layout === 'default' && (
            <>
              <Menu className={cx('menu')} theme={theme} items={menuItemsNodes} />

              <Burger
                className={cx('burger')}
                theme={currentTheme}
                isToggled={isBurgerToggled}
                onClick={onBurgerClick}
              />

              {linkTitle && linkUrl && (
                <Link className={cx('link')} to={linkUrl}>
                  {linkTitle}
                </Link>
              )}
              <Button className={cx('login-button')} to={buttonLink} theme={buttonTheme} size="sm">
                {buttonText}
              </Button>
            </>
          )}
        </div>
      </div>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
      <link
        href="https://fonts.googleapis.com/css2?family=Lato:wght@400;700;900&display=swap"
        rel="stylesheet"
      />
      <link rel="preconnect" href="https://www.googletagmanager.com/" />
      <link rel="preconnect" href="https://www.google-analytics.com/" />
      <link rel="preconnect" href="https://static.hotjar.com/" />
      <link rel="preconnect" href="https://stats.g.doubleclick.net" />
      <link rel="preconnect" href="https://script.hotjar.com/" />
      <link rel="preconnect" href="https://vars.hotjar.com/" />
      <link rel="preconnect" href="https://www.google.com/ads/" />
    </header>
  );
};

Header.defaultProps = {
  layout: 'default',
  theme: 'primary',
  withGradient: true,
};

Header.propTypes = {
  layout: PropTypes.oneOf(['default', 'only-logo']),
  theme: PropTypes.oneOf(['primary', 'secondary']),
  withGradient: PropTypes.bool,
  isBurgerToggled: PropTypes.bool.isRequired,
  onBurgerClick: PropTypes.func.isRequired,
};

export default Header;
